module.exports = __webpack_public_path__ + "img/515.4060713e.png";